import html2canvas from 'html2canvas-pro';

export const generateImageFromTemplate = async (element: HTMLElement): Promise<Blob | null> => {
    try {
        await new Promise(resolve => setTimeout(resolve, 100));

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            allowTaint: false,
            backgroundColor: null,
            logging: false,
            width: 1080,
            height: 1080,
            windowWidth: 1080,
            windowHeight: 1080,
            x: 0,
            y: 0,
            scrollX: 0,
            scrollY: 0,
            foreignObjectRendering: false,
        });

        return new Promise(resolve => {
            canvas.toBlob(
                blob => {
                    resolve(blob);
                },
                'image/jpeg',
                1,
            );
        });
    } catch (error) {
        console.error("Erreur lors de la génération de l'image:", error);
        return null;
    }
};

export const blobToFile = (blob: Blob, fileName: string): File => {
    return new File([blob], fileName, { type: 'image/jpeg' });
};
